module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_troendelag_pos.555a86d4.pdf";